const checkCredits = (obj: { planCreditChecks: number; purchasedCreditChecks: number }) =>
  obj.planCreditChecks > 0
    ? 'credit_checks'
    : obj.purchasedCreditChecks > 0
    ? 'credit_checks_additional_packages'
    : 'credit_checks'

export default checkCredits
